import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import ifInsuranceImgSrc from '@assets/if-insurance.svg'
import { Button } from '@root/components'
import { ActionBar, LogoContainer, StyledImg, StyledPageContent, StyledText } from './if.styled'

const IfInsuranceThankYou: React.FC = () => {
  const history = useHistory()
  const [t] = useTranslation()

  return (
    <StyledPageContent>
      <LogoContainer>
        <StyledImg src={ifInsuranceImgSrc} alt="If Insurance" />
      </LogoContainer>

      <StyledText style={{ textAlign: 'center', marginBottom: '0rem' }}>
        {t('ifInsurancePage.thankYou.description')}
      </StyledText>

      <ActionBar style={{ justifyContent: 'center' }}>
        <Button intent="success" onClick={() => history.goBack()}>
          {t('ifInsurancePage.thankYou.back')}
        </Button>
      </ActionBar>
    </StyledPageContent>
  )
}

export default IfInsuranceThankYou
